var _rect, _rect2, _rect3, _rect4, _g, _path, _g2, _g3, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _g4, _g5, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuddyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 135,
    viewBox: "0 0 155 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 55.9814,
    width: 154.973,
    height: 51.0421,
    rx: 25.521,
    fill: "url(#paint0_linear_438_1687)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.1875,
    y: 9.87891,
    width: 6.59459,
    height: 51.0421,
    rx: 3.2973,
    fill: "url(#paint1_linear_438_1687)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.0391,
    y: 24.6982,
    width: 70.8919,
    height: 51.0421,
    rx: 25.521,
    fill: "url(#paint2_linear_438_1687)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68.4141,
    width: 18,
    height: 18,
    rx: 9,
    fill: "url(#paint3_linear_438_1687)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_438_1687)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.42188,
    y: 36.2236,
    width: 140.135,
    height: 92.2051,
    rx: 46.1025,
    fill: "url(#paint4_linear_438_1687)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.42188,
    y: 36.2236,
    width: 140.135,
    height: 92.2051,
    rx: 46.1025,
    stroke: "#D1D1D1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.169 117.801C100.006 119.229 129.299 120.152 139.332 105.431C143.529 99.2736 145.627 93.8326 146.647 89.7012C147.997 84.2377 147.315 84.5878 145.327 89.8524C136.94 112.055 110.194 114.814 99.5958 115.014C96.7227 115.068 93.4757 116.799 96.169 117.801Z",
    fill: "url(#paint5_linear_438_1687)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_438_1687)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9792 116.488C93.9807 114.446 95.6409 112.79 97.6834 112.789C99.73 112.787 101.394 114.447 101.393 116.493C101.391 118.536 99.7312 120.191 97.6887 120.193C95.6421 120.194 93.9778 118.535 93.9792 116.488Z",
    fill: "url(#paint6_linear_438_1687)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9792 116.488C93.9807 114.446 95.6409 112.79 97.6834 112.789C99.73 112.787 101.394 114.447 101.393 116.493C101.391 118.536 99.7312 120.191 97.6887 120.193C95.6421 120.194 93.9778 118.535 93.9792 116.488Z",
    stroke: "#FBFBFB"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_438_1687)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 83.4718C30.5 67.3989 45.0363 55.1119 61.0784 56.1082C65.9564 56.4111 71.1146 56.6061 76.3118 56.6061C82.4072 56.6061 88.6097 56.3379 94.4462 55.9419C110.276 54.8678 124.473 67.0362 124.473 82.9025C124.473 94.0872 117.263 104.032 106.296 106.228C97.7094 107.947 87.0106 109.493 76.3118 109.493C65.9367 109.493 55.9976 108.039 48.0449 106.383C37.3613 104.159 30.5 94.3844 30.5 83.4718Z",
    fill: "url(#paint7_linear_438_1687)"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 42.0391,
    y: 97.9678,
    width: 71.7162,
    height: 2.46978,
    rx: 1.23489,
    fill: "url(#paint8_linear_438_1687)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 51.9297,
    y: 104.554,
    width: 51.9324,
    height: 2.46978,
    rx: 1.23489,
    fill: "url(#paint9_linear_438_1687)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 36.2734,
    y: 91.3818,
    width: 83.2568,
    height: 2.46978,
    rx: 1.23489,
    fill: "url(#paint10_linear_438_1687)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 32.1484,
    y: 84.7959,
    width: 92.3243,
    height: 2.46978,
    rx: 1.23489,
    fill: "url(#paint11_linear_438_1687)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 32.1484,
    y: 78.21,
    width: 92.3243,
    height: 2.46978,
    rx: 1.23489,
    fill: "url(#paint12_linear_438_1687)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 32.1484,
    y: 71.624,
    width: 92.3243,
    height: 2.46978,
    rx: 1.23489,
    fill: "url(#paint13_linear_438_1687)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 36.2734,
    y: 65.0371,
    width: 83.2568,
    height: 2.46978,
    rx: 1.23489,
    fill: "url(#paint14_linear_438_1687)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 42.0391,
    y: 58.4512,
    width: 71.7162,
    height: 2.46978,
    rx: 1.23489,
    fill: "url(#paint15_linear_438_1687)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_438_1687)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.6719,
    y: 68.3301,
    width: 19.7838,
    height: 26.3443,
    rx: 9.89189,
    fill: "url(#paint16_linear_438_1687)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_438_1687)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.5156,
    y: 68.3301,
    width: 19.7838,
    height: 26.3443,
    rx: 9.89189,
    fill: "url(#paint17_linear_438_1687)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_438_1687)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5938 100.871C67.5938 98.9253 69.8358 97.6594 71.6467 98.37C73.3525 99.0394 75.4191 99.6143 77.4856 99.6143C79.5522 99.6143 81.6188 99.0394 83.3246 98.37C85.1355 97.6594 87.3775 98.9253 87.3775 100.871C87.3775 101.855 86.7852 102.741 85.8509 103.05C84.0075 103.659 80.7466 104.554 77.4856 104.554C74.2247 104.554 70.9638 103.659 69.1204 103.05C68.1861 102.741 67.5938 101.855 67.5938 100.871Z",
    fill: "url(#paint18_linear_438_1687)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_438_1687",
    x: 2.92188,
    y: 33.7236,
    width: 149.133,
    height: 101.205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.157561 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_438_1687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_438_1687",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_438_1687"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_438_1687",
    x: 88.4766,
    y: 109.289,
    width: 18.4141,
    height: 18.4033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06474 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_438_1687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_438_1687",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_438_1687",
    x: 30.5,
    y: 55.876,
    width: 93.9766,
    height: 54.6172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_438_1687"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_438_1687",
    x: 63.6719,
    y: 43.3301,
    width: 73.7812,
    height: 80.3447,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.119165 0 0 0 0 0.908766 0 0 0 0 0.92731 0 0 0 0.741723 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_438_1687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_438_1687",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_438_1687",
    x: 17.5156,
    y: 43.3301,
    width: 73.7812,
    height: 80.3447,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.119165 0 0 0 0 0.908766 0 0 0 0 0.92731 0 0 0 0.741723 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_438_1687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_438_1687",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_438_1687",
    x: 40.5938,
    y: 73.1699,
    width: 73.7812,
    height: 60.3838,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.119165 0 0 0 0 0.908766 0 0 0 0 0.92731 0 0 0 0.741723 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_438_1687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_438_1687",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_438_1687",
    x1: 0,
    y1: 55.9814,
    x2: 0,
    y2: 107.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_438_1687",
    x1: 74.1875,
    y1: 53.1716,
    x2: 80.7821,
    y2: 53.1716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B6B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_438_1687",
    x1: 42.0391,
    y1: 24.6982,
    x2: 42.0391,
    y2: 75.7403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_438_1687",
    x1: 65.3794,
    y1: 7.40243,
    x2: 77.1519,
    y2: 21.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_438_1687",
    x1: 7.42188,
    y1: 36.2236,
    x2: 7.42188,
    y2: 128.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0269886,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF7F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_438_1687",
    x1: 94.5532,
    y1: 117.752,
    x2: 94.5532,
    y2: 81.5031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E6C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_438_1687",
    x1: 92.7258,
    y1: 115.833,
    x2: 97.5708,
    y2: 121.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984512,
    stopColor: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_438_1687",
    x1: 32.0415,
    y1: 54.5521,
    x2: 32.0415,
    y2: 109.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_438_1687",
    x1: 113.399,
    y1: 96.739,
    x2: 42.0391,
    y2: 96.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497815,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_438_1687",
    x1: 103.604,
    y1: 103.325,
    x2: 51.9297,
    y2: 103.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497815,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_438_1687",
    x1: 119.116,
    y1: 90.1531,
    x2: 36.2734,
    y2: 90.1531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497815,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_438_1687",
    x1: 124.014,
    y1: 83.5671,
    x2: 32.1484,
    y2: 83.5671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497815,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_438_1687",
    x1: 124.014,
    y1: 76.9812,
    x2: 32.1484,
    y2: 76.9812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497815,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_438_1687",
    x1: 124.014,
    y1: 70.3953,
    x2: 32.1484,
    y2: 70.3953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497815,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_438_1687",
    x1: 119.116,
    y1: 63.8084,
    x2: 36.2734,
    y2: 63.8084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497815,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_438_1687",
    x1: 113.399,
    y1: 57.2224,
    x2: 42.0391,
    y2: 57.2224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497815,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_438_1687",
    x1: 86.5218,
    y1: 73.0037,
    x2: 97.9782,
    y2: 97.2517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0244209,
    stopColor: "#95FFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E1B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_438_1687",
    x1: 40.3655,
    y1: 73.0037,
    x2: 51.822,
    y2: 97.2517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0244209,
    stopColor: "#95FFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E1B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_438_1687",
    x1: 63.8567,
    y1: 97.9472,
    x2: 65.1633,
    y2: 106.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93FFDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuddyLogo);
export default __webpack_public_path__ + "static/media/buddy_logo.9346fd85f4085e068670d54dc1cbdf43.svg";
export { ForwardRef as ReactComponent };